export class TelefoneCliente {
  public celular: string;
  public celularAdicional: string;
  public residencial: string;
  public comercial: string;

  constructor(data?: object) {
    this.trataTelefone(data);
  }

  trataTelefone(value: object) {
    if (value instanceof Array) {
      value.forEach(item => {
        if (item.categoria && item.categoria.id && item.ddd && item.telefone) {
          if (item.categoria.id === 1) {
            this.residencial = `${item.ddd}${item.telefone}`;
          }
          if (item.categoria.id === 2) {
            this.comercial = `${item.ddd}${item.telefone}`;
          }
          if (item.categoria.id === 3) {
            this.celular = `${item.ddd}${item.telefone}`;
          }
          if (item.categoria.id === 11) {
            this.celularAdicional = `${item.ddd}${item.telefone}`;
          }
        }
      });
    } else {
      this.celular = '';
      this.celularAdicional = '';
      this.comercial = '';
      this.residencial = '';
    }
  }
}
